import EditorAdvancedForm from './EditorAdvancedForm'

export default EditorAdvancedForm
